var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('div',[_c('div',{staticStyle:{"width":"100%","height":"267px"},attrs:{"id":_vm.id}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }